import React from "react"

const SafeImage = ({ imageArray, alt = "Image", className = "", height, width, containerClassName = "" }) => {
	if (!imageArray || !imageArray[0]?.url) {
		return null
	}

	const handleError = e => {
		console.error("Failed to load image:", imageArray[0].url)
		e.target.style.display = "none"
	}

	return (
		<div className={containerClassName}>
			<img
				src={imageArray[0].url}
				alt={alt}
				className={className}
				height={height}
				width={width}
				onError={handleError}
			/>
		</div>
	)
}

export default SafeImage

